import { CustomerSummary } from '@/common/api/params/customer'
import { dateTimeStr } from '@/common/form/date'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import Button, { ButtonColor } from '@/components/view/atoms/button/Button'
import TextButton from '@/components/view/atoms/button/TextButton'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'
import ItemAlign from '@/components/view/layouts/item/ItemAlign'

interface Props {
  customer: CustomerSummary
  onAnalysis(visitorId: string, customerId: string | null): void
}

const AccessCustomerListRow = ({ customer, onAnalysis }: Props) => {
  return (
    <TableRow>
      <TableRowItem>
        <Text size={14}>{customer.visitor_id || '-'}</Text>
      </TableRowItem>
      <TableRowItem>
        <ItemAlign>
          <Text size={14}>{customer.customer_id || '-'}</Text>
          <TextButton
            size={12}
            onClick={() => onAnalysis(customer.visitor_id, customer.customer_id)}
            arrow
          >
            分析
          </TextButton>
        </ItemAlign>
      </TableRowItem>
      <TableRowItem>
        <Text size={14}>{customer.delivery_count}</Text>
      </TableRowItem>
      <TableRowItem>
        <Text size={14}>{customer.view_count}</Text>
      </TableRowItem>
      <TableRowItem>
        <Text size={14}>{customer.view_product_count}</Text>
      </TableRowItem>
      <TableRowItem>
        <Text size={14}>{customer.cart_count}</Text>
      </TableRowItem>
      <TableRowItem>
        <Text size={14}>{customer.order_count}</Text>
      </TableRowItem>
      <TableRowItem>
        {customer.device_type ? (
          <Badge badgeType={BadgeType.SECONDARY} size={14}>
            {customer.device_type.toUpperCase()}
          </Badge>
        ) : (
          <Text color={TextColor.SECONDARY}>-</Text>
        )}
      </TableRowItem>
      <TableRowItem>
        <Text size={14} color={TextColor.SECONDARY}>
          {customer.first_seen ? dateTimeStr(customer.first_seen) : '-'}
        </Text>
      </TableRowItem>
      <TableRowItem>
        <Text size={14} color={TextColor.SECONDARY}>
          {customer.last_seen ? dateTimeStr(customer.last_seen) : '-'}
        </Text>
      </TableRowItem>
    </TableRow>
  )
}

export default AccessCustomerListRow
